;(function (angular, _) {
  'use strict'
  const KEY = 'vat-account-service'
  const EVENTS = {
    NEW: `${KEY}:new`, // On item create
    UPDATED: `${KEY}:updated`, // On item update
    DELETED: `${KEY}:deleted`, // On item delete
    CHANGE: `${KEY}:change` // On any events
  }
  const STRINGS = {
    NEW: 'Compte de TVA créé !',
    UPDATED: 'Compte de TVA sauvegardé !',
    DELETED: 'Compte de TVA supprimé !'
  }

  class VatAccountService {
    $rootScope
    $uibModal
    displayService
    snackService

    constructor (
      // Angular
      $rootScope,
      // Libs
      $uibModal,
      // Managers
      // Services
      DisplayService, SnackService
      // Const
      // Resolved
    ) {
      this.$rootScope = $rootScope
      this.$uibModal = $uibModal
      this.displayService = DisplayService
      this.snackService = SnackService
    }

    /**
     * @param {object} [initialValue={}]
     * @param {boolean} [skipEvent=true]
     * @return {Promise<Vat>}
     */
    create (initialValue = {}, skipEvent = true) {
      return this.$uibModal.open({
        size: 'lg',
        bindToController: true,
        resolve: {
          action: function () { return 'Créer' },
          account: ['VatManager', (VatManager) => {
            return VatManager.create(initialValue)
          }]
        },
        templateUrl: '/app/modules/preferences/accounting/create-account.html',
        controller: 'CreateAccountController',
        controllerAs: 'ctrl'
      }).result.then((account) => {
        return account.save().then(() => {
          if (!skipEvent) {
            this._broadcast(EVENTS.NEW, account)
          }
          this._snack(STRINGS.NEW)
          return account
        })
      })
    }

    /**
     *
     * @param vat {Vat}
     * @param {boolean} [skipEvent=true]
     * @return {Promise<void>}
     */
    delete (vat, skipEvent = true) {
      return this.displayService.confirmDeletion().then(() => {
        return vat.archive().then(() => {
          if (!skipEvent) {
            this._broadcast(EVENTS.DELETED, vat)
          }
          this._snack(STRINGS.DELETED)
          return vat
        })
      })
    }

    /**
     * @param vat {Vat}
     * @param {boolean} [skipEvent=true]
     * @return {Promise<Vat>}
     */
    edit (vat, skipEvent = true) {
      return this.$uibModal.open({
        size: 'lg',
        bindToController: true,
        resolve: {
          action: function () { return 'modifier' },
          account: function () { return angular.copy(vat) }
        },
        templateUrl: '/app/modules/preferences/accounting/create-account.html',
        controller: 'CreateAccountController',
        controllerAs: 'ctrl'
      }).result.then((account) => {
        return account.save().then(() => {
          if (!skipEvent) {
            this._broadcast(EVENTS.UPDATED, account)
          }
          this._snack(STRINGS.UPDATED)
          return account
        })
      })
    }

    _broadcast (event) {
      this.$rootScope.$broadcast(EVENTS.CHANGE)
      this.$rootScope.$broadcast(event)
    }

    _snack (string) {
      this.snackService.snack({
        text: string,
        delay: 5000
      })
    }
  }

  VatAccountService.$inject = [
    // Angular
    '$rootScope',
    // Libs
    '$uibModal',
    // Managers
    // Services
    'DisplayService', 'SnackService'
    // Const
    // Resolved
  ]

  angular.module('kilo.common.services')
    .service('VatAccountService', VatAccountService)
})(window.angular, window._)
